import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * Passo 8 (05/10/2026): o clique no push abre o destino com `?aviso=<id>`. Aqui o aviso é marcado como lido (igual ao clique no sino)
 * e o parâmetro sai da URL. Falha ao marcar não segura a pessoa.
 *
 * D3 (passo 19): a AÇÃO de marcar vem por prop — o interno passa o `markAsRead` do `NotificationContext`, o portal a mutação do
 * portal (o parceiro não tem o contexto interno). Fica num arquivo próprio para o portal não carregar o `NotificationContext`.
 * A ação é lida por ref: a do portal muda de identidade a cada render e não deve refazer o efeito (marcaria duas vezes).
 */
export function AvisoDaUrlComMarcador({
  marcarLida,
}: {
  marcarLida: (id: string) => unknown;
}): null {
  const { search, pathname, hash } = useLocation();
  const navigate = useNavigate();
  const marcarRef = useRef(marcarLida);
  marcarRef.current = marcarLida;

  useEffect(() => {
    const params = new URLSearchParams(search);
    const id = params.get("aviso");
    if (!id) return;
    params.delete("aviso");
    const resto = params.toString();
    navigate(`${pathname}${resto ? `?${resto}` : ""}${hash}`, { replace: true });
    try {
      Promise.resolve(marcarRef.current(id)).catch(() => undefined);
    } catch {
      // falha síncrona ao marcar também não segura a pessoa
    }
  }, [search, pathname, hash, navigate]);

  return null;
}
